import React from 'react';

import dotsIllutration from './../../assets/images/static/blueDots.jpg';

import { featurelist1 } from './FeaturesList';
import { featurelist2 } from './FeaturesList';

import {
  FeaturesSection,
  FeaturesHeading,
  HeadingTitle,
  FeaturesItems,
  FeaturesColumn,
  FeaturesThumbnail,
  StyledHeading,
  ImageIcon,
  SerialNumber,
  StyledDetails,
  ImgIllustration,
} from './styled';

const Features = () => {

  return (
    <FeaturesSection>
      <FeaturesHeading>
        <HeadingTitle>Our Features</HeadingTitle>
        <ImgIllustration 
          src={dotsIllutration}
          className='hideonMobile'
        />
      </FeaturesHeading>
      <FeaturesItems>
        <FeaturesColumn>
          {
            featurelist1.map((data) => (
              <FeaturesThumbnail className={data.class} key={data.serial}>
                <StyledHeading>
                  <ImageIcon src={data.source} alt={data.details} />
                  <SerialNumber>{data.serial}</SerialNumber>
                </StyledHeading>
                <StyledDetails>{data.details}</StyledDetails>
              </FeaturesThumbnail>
            ))
          }
        </FeaturesColumn>
        <FeaturesColumn>
          {
            featurelist2.map((data) => (
              <FeaturesThumbnail className={data.class} key={data.serial}>
                <StyledHeading>
                  <ImageIcon src={data.source} alt={data.details} />
                  <SerialNumber>{data.serial}</SerialNumber>
                </StyledHeading>
                <StyledDetails>{data.details}</StyledDetails>
              </FeaturesThumbnail>
            ))
          }
        </FeaturesColumn>
      </FeaturesItems>
    </FeaturesSection>
  )
}

export default Features;